import Vue from 'vue';
import axios from 'axios';
import Vuetable from 'vuetable-2/src/components/Vuetable.vue';
import VueEvents from 'vue-events';
import VuetablePagination from '@/components/generic/VueTablePagination.vue';

Vue.use(VueEvents);

export default {
  components: {
    VuetablePagination,
    Vuetable,
  },
  data() {
    return {
      loading: true,
      apiUrl: window.api_url,
      paginate: false,
      filterText: '',
      deleteModalVisible: false,
      editModalVisible: false,
      createModalVisible: false,
      massDeleteModalVisible: false,
      selectedRows: [],
      moreParams: {
        paginate: true,
      },
    };
  },
  mounted() {
    /* eslint-disable arrow-body-style */
    this.$watch(
      () => {
        return this.$refs.vuetable.selectedTo;
      },
      (selected) => {
        this.selectedRows = selected;
      },
    );
    /* eslint-enable */
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onLoading() {
      this.loading = true;
    },
    onLoaded() {
      this.loading = false;
    },
    httpFetch(apiUrl, httpOptions) {
      return axios.get(apiUrl, httpOptions);
    },
    getItems(url, params, itemName) {
      const vm = this;

      axios.get(url, params)
        .then((response) => {
          vm.$set(vm, itemName, response.data.data);
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
    createItem(itemURL, itemData) {
      const vm = this;

      axios.post(`${this.apiUrl}api/${itemURL}`, itemData)
        .then((response) => {
          vm.$toasted.show(response.data.message, { duration: 3000, singleton: true, type: 'success' });
          vm.$refs.vuetable.reload();
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
    editItem(itemURL, itemID, itemData) {
      const vm = this;

      this.editModalVisible = false;

      axios.patch(`${this.apiUrl}api/${itemURL}/${itemID}`, itemData)
        .then((response) => {
          vm.$toasted.show(response.data.message, { duration: 3000, singleton: true, type: 'success' });
          vm.$refs.vuetable.reload();
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
    deleteItem(itemURL, itemID) {
      const vm = this;

      axios.delete(`${this.apiUrl}api/${itemURL}/${itemID}`)
        .then((response) => {
          vm.$toasted.show(response.data.message, { duration: 3000, singleton: true, type: 'success' });
          vm.$refs.vuetable.reload();
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
    massDeleteItems(itemURL, itemData) {
      const vm = this;

      axios.delete(`${this.apiUrl}api/${itemURL}`, itemData)
        .then((response) => {
          vm.$toasted.show(response.data.message, { duration: 3000, singleton: true, type: 'success' });
          vm.$refs.vuetable.reload();
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
    doFilter() {
      this.moreParams = {
        filter: this.filterText,
        paginate: this.paginate,
      };

      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    resetFilter() {
      this.filterText = '';
      this.moreParams = {
        paginate: this.paginate,
      };

      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
  },
};
